import { Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import { useAppSelector } from "../store";
import cn from "classnames";
import { FC, useEffect } from "react";

const Main: FC = () => {
  return (
    <Layout className={cn("_backgroundColor", "_body")}>
      <Content>
        <Row className="app" justify={"center"} align="middle">
          <Col>
            <Outlet />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Main;
